const Tactic = require('../../entities/Tactic');
const { Age }  = require("../Constants");
const TacticNames = require("../Names/TacticNames");

class MechanizedArmy extends Tactic {
    constructor() {
        super(
            Age.Age3,
            TacticNames.MechanizedArmy,
            [0, 1, 2],
            "10(5)",
            {}
        )
    }
}

module.exports = MechanizedArmy;